import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Slider from './components/Slider';
import Services from './components/Services';
import About from './components/About';
import WhyChooseUs from './components/WhyChooseUs';
import Partners from './components/Partners';
import TrackShipment from './components/TrackShipment';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import OurTeam from './components/OurTeam';
import OceanFreight from './components/Services/OceanFreight';
import AirFreight from './components/Services/AirFreight';
import CargoExpress from './components/Services/CargoExpress';
import Logistics from './components/Services/Logistics';
import Warehousing from './components/Services/Warehousing';
import Gallery from './components/Gallery';
import ContactUs from './components/ContactUs';
import Disclaimer from './components/Disclaimer';
import Careers from './components/Careers';
import PrivacyPolicy from './components/PrivacyPolicy';
import Locations from './components/Locations';
import GetAquote from './components/GetAquote';
import TrackShipmentPage from './components/TrackShipmentPage';

function App() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <main>
        <Routes>
          {/* Homepage */}
          <Route
            path="/"
            element={
              <>
                <Slider />
                <Services />
                <About />
                <WhyChooseUs />
                <Partners />
                <TrackShipment />
              </>
            }
          />
          {/* About Us */}
          <Route path="/about" element={<AboutUs />} />
          {/* Our Team */}
          <Route path="/our-team" element={<OurTeam />} />
          {/* Services Sub-Routes */}
          <Route path="/services">
            <Route index element={<Services />} />
            <Route path="ocean-freight" element={<OceanFreight />} />
            <Route path="air-freight" element={<AirFreight />} />
            <Route path="cargo-express" element={<CargoExpress />} />
            <Route path="logistics" element={<Logistics />} />
            <Route path="warehousing" element={<Warehousing />} />
          </Route>
          {/* Gallery */}
          <Route path="/gallery" element={<Gallery />} />
          {/* Contact Us */}
          <Route path="/contact" element={<ContactUs />} />
          {/* Disclaimer */}
          <Route path="/disclaimer" element={<Disclaimer />} />
          {/* Careers */}
          <Route path="/careers" element={<Careers />} />
          {/* Privacy Policy */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          {/* Locations */}
          <Route path="/locations" element={<Locations />} />
          {/* Get a Quote */}
          <Route path="/get-a-quote" element={<GetAquote />} />
          {/* Track Shipment */}
          <Route path="/track-shipment" element={<TrackShipmentPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;